<template>
  <div v-if="!userProfile.checked && jwtAccessValid() && isDeliverer" class="container pt-3 d-flex justify-content-center">
    <div class="shadow bg-body rounder p-4">
      <h3 class="text-center mb-3">Подтверждение учетной записи</h3>
      <p>
        Для подтверждения учетной записи необходимо загрузить фото паспорта.
      </p>
      <form v-if="!userProfile.passportUploaded" @submit.prevent="upload">
        <div class="row">
          <label for="main" class="form-label mb-0"
            >Разворот 1 и 2 страницы</label
          >
          <input
            class="form-control"
            type="file"
            id="main"
            accept="image/*"
            @change="handleFileUpload"
          />
        </div>
        <div class="mt-3 row">
          <label for="address" class="form-label mb-0"
            >Прописка</label
          >
          <input
            class="form-control"
            type="file"
            id="address"
            accept="image/*"
            @change="handleFileUpload"
          />
        </div>
        <div class="row mt-3">
          <button class="btn btn-primary" type="submit" :disabled="!readyToUpload">
            Отправить на проверку
          </button>
        </div>
      </form>
      <div v-if="userProfile.passportUploaded && !userProfile.checked">
        <span>Паспорт загружен. Ожидайте окончания проверки.</span>
      </div>
      <div v-if="!status" class="mt-3 text-danger text-center">
        <span>Ошибка отправки</span>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, nextTick } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import useCommonMixin from '@/components/commonMixin.js'

export default {
  name: "UploadPassport",

  setup(props) {
    const store = useStore()
    useCommonMixin()
    const { jwtAccessValid, isDeliverer } = useCommonMixin()

    const passportImg = ref({
      main: "",
      address: "",
    });

    const status = ref(true)

    const upload = async () => {
      if (readyToUpload.value) {
        let response = await store.dispatch('uploadPassport', passportImg.value)
        await store.dispatch("FETCHuserProfile", { userId: null, phone: null })
        if (!response.status) {
          console.log('Ошибка отправки. Попробуйте позже.')
          status.value = false
        } else {
          passportImg.value = {
            main: "",
            address: "",
          }
        }
      }
    }

    const readyToUpload = computed(() => {
      return (passportImg.value.main && passportImg.value.address)
    })

    const handleFileUpload = (event) => {
      status.value = true
      let file = event.target.files[0]
      let page = event.target.id
      if (file && page) {
        passportImg.value[page] = file
      }

      console.log("file", file)
      console.log('page', page)
      
      /*
      let formData = new FormData()
      formData.append("file", file)

      axios.post("http://localhost:3005/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
*/

      /*
      axios
        .get("http://localhost:3005/download", {
          responseType: "arraybuffer",
        })
        .then((response) => {
          img.value = Buffer.from(response.data, "binary").toString("base64");
        });
*/
    };

    return {
      handleFileUpload,
      upload,
      readyToUpload,
      userProfile: computed(() => store.getters.userProfile),
      status,
      jwtAccessValid,
      isDeliverer,
    };
  },
};
</script>

<style>
</style>